import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { installGtag } from "./lib/gtag";
const smoothscroll = require("smoothscroll-polyfill");

smoothscroll.polyfill();
installGtag();

ReactDOM.render(
  // TODO: StrictMode is commented to avoid double rendering issue during gtag implementation
  // <React.StrictMode>
  <App />,
  // </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
